export default __webpack_public_path__ + "static/media/back.c7da4c35.svg";